import { defineComponent, createBlock, openBlock, unref, mergeProps, withCtx, renderSlot } from "vue";
import { TooltipTrigger_default } from "../../../../node_modules/.pnpm/reka-ui@2.5.1_patch_hash_1a_fe91be2ae044c59728f130150abaf78d/node_modules/reka-ui/dist/Tooltip/TooltipTrigger.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TooltipTrigger",
  props: {
    reference: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => (openBlock(), createBlock(unref(TooltipTrigger_default), mergeProps({ "data-slot": "tooltip-trigger" }, props, { "as-child": "" }), {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=TooltipTrigger.vue.js.map
